import apiClient, { type PagedResponse } from '../../client'
import type {
  MineralTypeItem,
  CreateMineralTypeRequest,
  UpdateMineralTypeRequest,
  GetMineralTypesParams,
} from '../../models/maestros.models'

const BASE_PATH = '/maestros/mineral-types'

export const mineralTypesCatalogService = {
  async getAll(params?: GetMineralTypesParams): Promise<PagedResponse<MineralTypeItem>> {
    return apiClient.get<PagedResponse<MineralTypeItem>>(BASE_PATH, params)
  },
  async getById(id: string): Promise<MineralTypeItem> {
    return apiClient.get<MineralTypeItem>(`${BASE_PATH}/${id}`)
  },
  async create(data: CreateMineralTypeRequest): Promise<MineralTypeItem> {
    return apiClient.post<MineralTypeItem, CreateMineralTypeRequest>(BASE_PATH, data)
  },
  async update(id: string, data: UpdateMineralTypeRequest): Promise<MineralTypeItem> {
    return apiClient.put<MineralTypeItem, UpdateMineralTypeRequest>(`${BASE_PATH}/${id}`, data)
  },
  async delete(id: string): Promise<void> {
    return apiClient.delete<void>(`${BASE_PATH}/${id}`)
  },
}
